// extracted by mini-css-extract-plugin
export var hidden = "_u5-0";